import { useState } from "react";

const PwaUpdateNotice = ({ status, refresh }) => {
  const [help, setHelp] = useState(false);
  if (status !== "stale") return null;

  return (
    <div className="pwa-update-overlay" role="alertdialog" aria-modal="true" aria-label="Обновление приложения">
      <div className="pwa-update-card">
        <div className="pwa-update-title">Обновите приложение</div>
        <div className="pwa-update-hint">Версия на телефоне отличается от сайта</div>
        <button type="button" className="press btn-accent pwa-update-button" onClick={refresh}>
          Обновить
        </button>
        <button type="button" className="pwa-update-secondary" onClick={() => setHelp(true)}>
          Не обновляется
        </button>
        {help && (
          <div className="pwa-update-help">
            Удалите Бомбилу с главного экрана и установите заново с bombila.online
          </div>
        )}
      </div>
    </div>
  );
};

export default PwaUpdateNotice;
